import React from "react";
import { LineChart, ShieldCheck, Layers } from "lucide-react";

function Container({ children, className = "" }) {
  return <div className={`mx-auto w-full max-w-6xl px-4 ${className}`}>{children}</div>;
}

export default function Portfolio() {
  return (
    <div className="min-h-screen bg-white">
      <Container className="py-10">
        <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-950">
          <LineChart className="h-4 w-4" />
          Portfolio
        </div>

        <h1 className="mt-4 text-3xl font-semibold tracking-tight sm:text-4xl text-slate-900">
          Portfolio dashboard (premium UI mock)
        </h1>
        <p className="mt-2 max-w-2xl text-slate-600">
          This page makes your brand feel like a real platform even before full backend features.
        </p>

        <div className="mt-8 grid gap-6 md:grid-cols-3">
          <div className="rounded-3xl border border-emerald-900/10 bg-white p-6 shadow-sm md:col-span-2">
            <div className="text-sm font-semibold text-slate-900">Performance</div>
            <div className="mt-2 rounded-2xl bg-slate-50 p-6">
              <div className="text-xs text-slate-600">Last 12 months</div>
              <div className="mt-2 text-3xl font-semibold text-emerald-950">+12.4%</div>
              <div className="mt-2 text-sm text-slate-600">
                Benchmark: NIFTY50 +11.1% (example)
              </div>
            </div>
          </div>

          <div className="rounded-3xl border border-emerald-900/10 bg-white p-6 shadow-sm">
            <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
              <ShieldCheck className="h-4 w-4 text-emerald-950" />
              Risk profile
            </div>
            <div className="mt-3 rounded-2xl bg-emerald-50 p-5">
              <div className="text-xs text-emerald-900/70">Current</div>
              <div className="mt-1 text-xl font-semibold text-emerald-950">Balanced</div>
              <div className="mt-2 text-sm text-emerald-900/80">Equity 60% • Debt 35% • Cash 5%</div>
            </div>
          </div>

          <div className="rounded-3xl border border-emerald-900/10 bg-white p-6 shadow-sm">
            <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
              <Layers className="h-4 w-4 text-emerald-950" />
              Allocation
            </div>
            <div className="mt-4 space-y-3 text-sm text-slate-700">
              <Row label="Equity" value="60%" />
              <Row label="Debt" value="35%" />
              <Row label="Cash" value="5%" />
            </div>
            <div className="mt-4 text-xs text-slate-500">
              Next: add rebalancing alerts when allocation drifts.
            </div>
          </div>

          <div className="rounded-3xl border border-emerald-900/10 bg-white p-6 shadow-sm md:col-span-2">
            <div className="text-sm font-semibold text-slate-900">Rebalancing (example)</div>
            <div className="mt-3 grid gap-3 sm:grid-cols-2">
              <div className="rounded-2xl bg-slate-50 p-5">
                <div className="text-xs text-slate-600">Alert</div>
                <div className="mt-1 font-semibold text-slate-900">Equity allocation drifted +6%</div>
                <div className="mt-2 text-sm text-slate-600">Suggested: move part to debt to restore balance.</div>
              </div>
              <div className="rounded-2xl bg-slate-50 p-5">
                <div className="text-xs text-slate-600">Action</div>
                <div className="mt-1 font-semibold text-slate-900">Review & rebalance</div>
                <div className="mt-2 text-sm text-slate-600">Add “Book advisor call” CTA here later.</div>
              </div>
            </div>
          </div>
        </div>

        <p className="mt-6 text-xs text-slate-500">
          These numbers are examples. Replace with real data once backend portfolio is ready.
        </p>
      </Container>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between rounded-xl bg-slate-50 px-4 py-3">
      <div className="text-slate-700">{label}</div>
      <div className="font-semibold text-slate-900">{value}</div>
    </div>
  );
}
